import { Component, inject } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { TranslateModule } from '@ngx-translate/core';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';
import { SafeHtmlPipe } from 'src/app/shared/pipes/safe-html.pipe';

import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { CloudinaryService } from 'src/app/core/services/cloudinary.service';

import { TripWizardComponent } from 'src/app/shared/components/trip-wizard/trip-wizard.component';
import { TestimonialsComponent } from 'src/app/shared/components/testimonials/testimonials.component';
import { PlanningFormSheetComponent } from 'src/app/shared/sheets/planning-form-sheet/planning-form-sheet.component';
import { StartPlaningMobileComponent } from 'src/app/shared/components/start-planing-mobile/start-planing-mobile.component';

import { Config } from 'src/app/core/configs/config';

interface IImageObject {
  imageUrl: string;
  maxWidth: number;
  maxHeight: number;
}

@Component({
  selector: 'app-trip-planner-welcome',
  imports: [
    TranslateModule,
    MatIcon,
    TripWizardComponent,
    TestimonialsComponent,
    StartPlaningMobileComponent,
    SafeHtmlPipe,
    SafeUrlPipe,
  ],
  templateUrl: './trip-planner-welcome.component.html',
  styleUrl: './trip-planner-welcome.component.scss',
})
export class TripPlannerWelcomeComponent {
  HOW_IT_WORKS_IMAGES: IImageObject[][] = [
    [
      {
        imageUrl: 'tp-empty-1.png',
        maxHeight: 55,
        maxWidth: 975,
      },
    ],
    [{ imageUrl: 'tp-empty-2.png', maxHeight: 325, maxWidth: 941 }],
    [
      { imageUrl: 'tp-empty-3.png', maxHeight: 325, maxWidth: 315 },
      { imageUrl: 'tp-empty-4.png', maxHeight: 325, maxWidth: 181 },
    ],
    [{ imageUrl: 'tp-empty-5.png', maxHeight: 325, maxWidth: 782 }],
    [{ imageUrl: 'tp-empty-6.png', maxHeight: 325, maxWidth: 652 }],
    [{ imageUrl: 'tp-empty-7.png', maxHeight: 350, maxWidth: 678 }],
    [{ imageUrl: 'tp-empty-8.png', maxHeight: 268, maxWidth: 972 }],
  ];
  HOW_IT_WORKS_IMAGES_MOBILE: IImageObject[][] = [
    [{ imageUrl: 'mobile-tp-empty-1.png', maxHeight: 300, maxWidth: 350 }],
    [{ imageUrl: 'mobile-tp-empty-2.png', maxHeight: 350, maxWidth: 350 }],
    [{ imageUrl: 'mobile-tp-empty-3.png', maxHeight: 400, maxWidth: 350 }],
    [{ imageUrl: 'mobile-tp-empty-4.png', maxHeight: 300, maxWidth: 350 }],
    [{ imageUrl: 'mobile-tp-empty-5.png', maxHeight: 350, maxWidth: 350 }],
    [{ imageUrl: 'mobile-tp-empty-6.png', maxHeight: 400, maxWidth: 350 }],
  ];
  CURIOUS_ABOUT_IMAGES: IImageObject[][] = [
    [
      { imageUrl: 'tp-empty-9.png', maxHeight: 313, maxWidth: 326 },
      { imageUrl: 'tp-empty-10.png', maxHeight: 313, maxWidth: 326 },
      { imageUrl: 'tp-empty-11.png', maxHeight: 313, maxWidth: 326 },
    ],
    [{ imageUrl: 'tp-empty-12.png', maxHeight: 311, maxWidth: 622 }],
  ];

  protected heroBgUrl: string = `${Config.imgCdnUrl}images/main-bg.jpg`;
  protected eSvgIcons = ESvgIcons;

  readonly breakpointService = inject(BreakpointService);

  readonly #matBottomSheet = inject(MatBottomSheet);
  readonly #cloudinaryService = inject(CloudinaryService);

  constructor() {
    const setCloudinaryImages = (imagesObj: IImageObject[][]) => {
      imagesObj.forEach((images: IImageObject[]) => {
        images.forEach((item) => {
          item.imageUrl = `${this.#cloudinaryService.getCloudImage(`${Config.imgCdnUrl}images/` + item.imageUrl)}`;
        });
      });
    };

    if (this.breakpointService.isMobile()) {
      this.heroBgUrl = this.heroBgUrl.replace('main-bg', 'main-bg-mobile');
    }

    this.heroBgUrl = `url(${this.#cloudinaryService.getCloudImage(
      this.heroBgUrl,
      true,
    )})`;
    setCloudinaryImages(this.HOW_IT_WORKS_IMAGES);
    setCloudinaryImages(this.CURIOUS_ABOUT_IMAGES);
    setCloudinaryImages(this.HOW_IT_WORKS_IMAGES_MOBILE);
  }

  goToPlanningForm(): void {
    this.#matBottomSheet.open(PlanningFormSheetComponent, {
      hasBackdrop: false,
      closeOnNavigation: true,
      panelClass: 'custom-bottom-sheet',
    });
  }
}
